import { Routes } from '@angular/router';
import { inactiveSessionGuard } from './shared/guards/inactive-session.guard';
import { activeSessionGuard } from './shared/guards/active-session.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./session/session.routes').then((m) => m.routes),
    canActivate: [inactiveSessionGuard],
  },
  {
    path: 'app',
    loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.routes),
    canActivate: [activeSessionGuard],
    data: {
      breadcrumb: 'BREADCRUMBS.DASHBOARD',
    },
  },
];
